import type {
  ProviderOwnerChecklistItemDto,
  ProviderOwnerOnboardingStatus,
  ProviderOwnerStatusDto,
} from "./provider-owner.types";

export function providerOwnerStatusLabel(
  status: ProviderOwnerOnboardingStatus,
): string {
  switch (status) {
    case "LEAD_CREATED":
      return "Lead created";
    case "DRAFT_IN_PROGRESS":
      return "Draft in progress";
    case "AWAITING_PROVIDER_COMPLETION":
      return "Awaiting provider completion";
    case "READY_FOR_BDO_REVIEW":
      return "Ready for BDO review";
    case "READY_FOR_OPS_APPROVAL":
      return "Ready for Ops approval";
    case "APPROVED":
      return "Approved";
    case "ACTIVATION_PENDING":
      return "Activation pending";
    case "ACTIVE":
      return "Active";
    case "RETURNED_BY_BDO":
      return "Returned by BDO";
    case "RETURNED_BY_OPS":
      return "Returned by Ops";
    case "REJECTED":
      return "Rejected";
    default:
      return "Draft";
  }
}

export function providerOwnerStatusTone(
  status: ProviderOwnerOnboardingStatus,
): "neutral" | "info" | "warning" | "success" | "danger" {
  switch (status) {
    case "LEAD_CREATED":
    case "DRAFT_IN_PROGRESS":
      return "neutral";
    case "AWAITING_PROVIDER_COMPLETION":
    case "READY_FOR_BDO_REVIEW":
    case "READY_FOR_OPS_APPROVAL":
    case "ACTIVATION_PENDING":
      return "warning";
    case "APPROVED":
    case "ACTIVE":
      return "success";
    case "RETURNED_BY_BDO":
    case "RETURNED_BY_OPS":
      return "info";
    case "REJECTED":
      return "danger";
    default:
      return "neutral";
  }
}

export function providerChecklistCompletionPercent(
  checklist: ProviderOwnerChecklistItemDto[],
): number {
  if (!checklist.length) return 0;
  const completed = checklist.filter((item) => item.completed).length;
  return Math.round((completed / checklist.length) * 100);
}

export function providerPendingBlockers(
  checklist: ProviderOwnerChecklistItemDto[],
): number {
  return checklist.filter((item) => item.blocking && !item.completed).length;
}

export function providerStatusSummary(dto: ProviderOwnerStatusDto): string {
  return `${providerOwnerStatusLabel(dto.status)} · ${dto.overallCompletionPercent}% complete`;
}